import { useGetCourseAccessLevelQuery, useLazyIncarnateSuggestQuery } from '../mrWolfApi';

export const useCourseAccessLevel = (params = {}) => {
  return useGetCourseAccessLevelQuery(params, {
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      courseAccessLevel: data,
      isLoading,
      isError,
      error,
    }),
  });
};

export const useIncarnateSuggest = () => {
  return useLazyIncarnateSuggestQuery({
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      userSuggest: data || [],
      isLoading,
      isError,
      error,
    }),
  });
};
